import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { clearOfflineCache } from "@/lib/offline";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then(({ data }) => { setUser(data); localStorage.setItem("user_cache", JSON.stringify(data)); })
      .catch((e) => {
        // Çevrimdışı: oturumu koru, son bilinen kullanıcıyla devam et
        const cached = localStorage.getItem("user_cache");
        if (e?.response?.status === 401) localStorage.removeItem("token");
        else if (cached) setUser(JSON.parse(cached));
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    localStorage.setItem("user_cache", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_cache");
    setUser(null);
    clearOfflineCache();
  };

  const can = (key) => user?.role === "admin" || !!user?.permissions?.[key];
  const hasModule = (m) => user?.role === "admin" || (user?.modules ? user.modules.includes(m) : m === "kumes");
  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data); localStorage.setItem("user_cache", JSON.stringify(data));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can, hasModule, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}
